import { useEffect } from 'react';

export const useHideHeaderOnMount = headerActions => {
    useEffect(() => {
        headerActions.hideHeader();

        return () => {
            headerActions.showHeader();
        };
    }, [headerActions]);
};
